import React, { useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { FileCopySharp, Visibility } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
import moment from 'moment';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsFindBy, wsPost } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { wsUpdate } from 'services/WService';
import { Link } from 'react-router-dom';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 110 },
  { Header: 'Periodo', accessor: 'periodo', width: 150 },
  { Header: 'Zona', accessor: 'zonas', width: 150 },
  { Header: 'Código supervisor', accessor: 'code', width: 180 },
  { Header: 'Supervisor', accessor: 'supervisor_name' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];
const permission = {
  store: 'INCENTIVOS_TIPO_INCENTIVOS_STORE',
  show: 'INCENTIVOS_TIPO_INCENTIVOS_SHOW',
  delete: 'INCENTIVOS_TIPO_INCENTIVOS_DELETED',
};
export default WithApp(function Colgate(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [cuotas, setCuotas] = useState([]);
  const [valueSearch, setValueSearch] = useState({});
  const [currentPeriod, setCurrentPeriod] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);

  const handleChange = (id, value) => {
    const index = cuotas.findIndex((item) => item.id == id);
    cuotas[index].importe = value;
    setCuotas([...cuotas]);
  };
  async function loadCuotas(filter) {
    setDataLoading(true);
    let response = await wsFindBy('sale/softy-supervisor', filter);
    setDataLoading(false);
    if (response.success) setCuotas(response.data);
  }
  async function updateCuota(id, value) {
    setDataLoading(true);
    let response = await wsUpdate('sale/softy-supervisor', id, { importe: value });
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      console.log('Datos devueltos: ', response.data)
      loadCuotas(valueSearch);
    } else {
      showNotify(response.message, 'error');
    }
  }
  
  async function transferirRegistros(sourceperiodo, targetperiodo) {
    setDataLoading(true);
    let response = await wsPost('sale/softy-supervisor/transferir-registros', {
      SourcePeriodo: sourceperiodo,
      TargetPeriodo: targetperiodo,
    });
    setDataLoading(false);

    if (response.success) {
      showNotify(response.message);
      console.log('Transferencia exitosa: ', response.data);
      loadCuotas(valueSearch);
    } else {
      showNotify(response.message, 'error');
      console.error('Error al transferir registros: ', response);
    }
  }

  const handleFilterChange = (value) => {
    const period = parseInt(moment(value.periodo).format('YYYYMM'), 10);
    setCurrentPeriod(period);
  };

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={() => loadCuotas(valueSearch)}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard permission={ConstantPermissions[permission.store]}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de supervisores {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterCustom
              getFilter={loadCuotas}
              getValueSearch={(value) => {
                setValueSearch(value);
                handleFilterChange(value);
              }}
              date
              dateType="month"
              labelDate="periodo"
              dateField="periodo"
            />
            <Button
              color="danger"
              onClick={() => {
                const sourcePeriod = moment(currentPeriod.toString(), "YYYYMM").subtract(1, "month").format("YYYYMM");
                transferirRegistros(Number(sourcePeriod), currentPeriod);
              }}>
              Inicializar cuotas de supervisor
            </Button>
            <ReactTable
              excelName="cuotas_de_proveedor"
              formatDate="DD-MM-YYYY"
              defaultWidth={1300}
              columns={columns}
              data={cuotas.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions[permission.show]}>
                        <Button justIcon round simple color={props.themeContext.buttonColorWarning}>
                          <Link to={`${item.id}`}>
                            <Visibility />
                          </Link>
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions[permission.delete]}>
                        <ButtonDelete
                          entity="sale/softy-supervisor"
                          id={item.id}
                          
                          reload={() => {
                            setDataLoading(true);
                            loadCuotas(valueSearch).then(() => setDataLoading(false));
                        }}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  periodo: item.periodo,
                  code: item.code,
                  supervisor_name: item.supervisor_name,
                  zonas: item.zonas,
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
